export default __webpack_public_path__ + "static/card_01-d110dc885d4f247ff839b4a4f3ebdfda.png";